import React from 'react';
import { FaUserPlus, FaPlus, FaUpload, FaTrash, FaUserCircle } from 'react-icons/fa';

const BookingdetailsPage = () => {
  return (
    <div className="w-full min-h-screen flex flex-col bg-gradient-to-br from-blue-50 to-purple-50">
      {/* Header Section */}
      <div className="bg-white shadow-lg p-3 flex justify-between items-center">
        <h2 className="text-2xl font-bold text-gray-800">Account Details</h2>
        <div className="flex gap-4">
          <button className="flex items-center gap-2 px-5 py-2.5 bg-gray-100 rounded-lg text-sm text-gray-700 hover:bg-gray-200 transition-all">
            <FaUserPlus className="text-lg" /> Invite User
          </button>
          <button className="flex items-center gap-2 px-5 py-2.5 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 transition-all">
            <FaPlus className="text-lg" /> Create
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex flex-col items-center justify-center flex-grow p-8">
        <div className="bg-white shadow-2xl rounded-2xl p-8 w-full max-w-7xl">
          {/* Profile Picture Upload */}
          <div className="flex items-center gap-6 mb-8">
            <FaUserCircle className="text-6xl text-gray-400" />
            <div className="flex gap-3">
              <button className="flex items-center gap-2 px-5 py-2.5 bg-cyan-500 text-white rounded-lg text-sm hover:text-black transition-all">
                <FaUpload className="text-lg" /> Upload
              </button>
              <button className="flex items-center gap-2 px-5 py-2.5 bg-red-500 text-white rounded-lg text-sm hover:text-black transition-all">
                <FaTrash className="text-lg" /> Remove
              </button>
            </div>
          </div>

          <form className="space-y-6">
            {/* First Name and Last Name */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <InputField label="First Name" />
              <InputField label="Last Name" />
            </div>

            {/* Check-In and Check-Out Dates */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <InputField label="Check-In Date" type="date" />
              <InputField label="Check-Out Date" type="date" />
            </div>

            {/* Room Type and Room Number */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <InputField label="Room Type" />
              <InputField label="Room Number" />
            </div>

            {/* Total Guests and Total Days to Stay */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <InputField label="Total Guests" type="number" />
              <InputField label="Total Days to Stay" type="number" />
            </div>

            <InputField label="Booking Type" />

            {/* Buttons */}
            <div className="flex justify-end gap-4 mt-8">
              <button className="px-6 py-2.5 bg-cyan-500 text-white rounded-lg text-sm hover:text-black transition-all">
                Save Changes
              </button>
              <button className="px-6 py-2.5 bg-red-500 text-white rounded-lg text-sm hover:text-black transition-all">
                Delete Account
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const InputField = ({ label, type = 'text' }) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
      <input
        type={type}
        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm bg-white f  focus:border-transparent transition-all"
      />
    </div>
  );
};

export default BookingdetailsPage;
